import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ArchitectingGenerationalWealth() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="architecting-generational-wealth" className="dark bg-background text-foreground w-full min-h-screen flex flex-col lg:flex-row">
      {}
      <div className="w-full lg:w-[60%] relative min-h-[50vh] lg:min-h-auto overflow-hidden order-1 lg:order-1">
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1563866/img/charlotte_skyline_blue_hour.png)]">
          {}
          <div className="absolute inset-0 bg-black/10" />
        </div>
      </div>

      {}
      <div className="w-full lg:w-[40%] bg-[#F2F0E6] text-[hsl(222,47%,11%)] flex flex-col justify-center px-8 py-16 lg:px-16 xl:px-24 relative order-2 lg:order-2">
        <div ref={ref} className={cn("flex flex-col items-start max-w-lg mx-auto lg:mx-0 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h1 className="font-serif text-5xl md:text-[64px] leading-[1.1] mb-8 tracking-tight text-[hsl(222,47%,11%)]">
            Architecting Generational Wealth
          </h1>
          <p className="font-sans text-lg md:text-xl leading-relaxed text-[hsl(222,47%,11%)]/80 mb-12">
            Cyradon Capital serves wealth building and asset protection, real estate investors, and business owners across the Carolinas. We provide sophisticated tax strategies and comprehensive financial planning to secure and grow your legacy.
          </p>

          <Link to="/WealthArchitecturePage">
            <Button size="lg" className="relative overflow-hidden bg-[hsl(222,47%,11%)] text-[#F2F0E6] hover:bg-[hsl(222,47%,15%)] rounded-none px-10 py-7 text-base tracking-wide group border-none shadow-lg cursor-pointer">
              <span className="relative z-10 flex items-center gap-2 font-medium">
                Initiate Strategy
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
              {}
              <span className="absolute inset-0 bg-[linear-gradient(110deg,transparent_25%,rgba(255,255,255,0.15)_50%,transparent_75%)] bg-[length:250%_100%] bg-[position:-100%_0] group-hover:bg-[position:200%_0] transition-[background-position] duration-[1500ms] ease-in-out z-0" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}